export const baseUrl = "https://api.maedehacademy.com";
// export const baseUrl = "http://192.168.10.138:8002";
